/**
 * Re-export the shared GraphModal component for backward compatibility.
 * New code should import directly from @unlikelyai-magic/shared/components.
 */
import { type ReactNode } from "react";
import {
  QuestionAnswer,
  GraphModal as SharedGraphModal,
} from "@unlikelyai-magic/shared/components";
import { ProductTree } from "@unlikelyai-magic/shared/data-access/api";

export interface GraphModalProps {
  productTree: ProductTree;
  questionAnswers?: QuestionAnswer[];
  onClose: () => void;
  explanation?: ReactNode;
}

/**
 * GraphModal component - displays a decision tree in a modal.
 * This is a wrapper around the shared GraphModal component for backward compatibility.
 */
export const GraphModal = ({
  productTree,
  questionAnswers,
  onClose,
  explanation,
}: GraphModalProps) => {
  return (
    <SharedGraphModal
      tree={productTree}
      questionAnswers={questionAnswers ?? []}
      onClose={onClose}
      explanation={explanation}
    />
  );
};
